import React, { useRef } from 'react';
import FeedPostSlider from 'molecules/FeedPostSlider/FeedPostSlider';
import useProductFeedPosts from 'src/hooks/useProductFeedPosts';

const BehindResultsFeed = (): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const posts = useProductFeedPosts({ containerRef });

  return <FeedPostSlider posts={posts} ref={containerRef} />;
};

export default BehindResultsFeed;
